import { FormattedHTMLMessage } from "react-intl";

import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";

import { DEFAULT_LOCALE } from "../../../constants";
import { type FormFieldComponentProps } from "../../../lib/types/types";
import { DateComponent } from "../../DateComponent/DateComponent";

type Props = Omit<FormFieldComponentProps, "isErrored"> & {
  locale: string;
  /**
   * @deprecated deprecated in favor of using errorId instead
   */
  isErrored?: boolean;
};

export const BirthDateComponent = ({
  onChange,
  isRequired = true,
  errorId,
  isErrored = !!errorId,
  value = "2000-01-01",
  locale = DEFAULT_LOCALE,
  disabled = false,
}: Props) => {
  const isFieldHidden = getFieldConfigByFieldId("birthDate")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <DateComponent
      value={value}
      label={<FormattedHTMLMessage id="birthDate" defaultMessage="Date of birth" />}
      explanation={
        <FormattedHTMLMessage
          id="verificationPurposesOnly"
          defaultMessage="Used for verification purposes only"
        />
      }
      onChange={onChange}
      fieldId="birthdate"
      fieldName="birthDate"
      isErrored={isErrored}
      isRequired={isRequired}
      locale={locale}
      disabled={disabled}
      autoComplete="bday"
      errorMsg={
        <FormattedHTMLMessage id={`errorId.${errorId}`} defaultMessage="Invalid birth date" />
      }
    />
  );
};
